import { useState } from 'react';

export default function ServingStepper({ min = 1, max = 1, step = 1, value = 1 }) {
  const [count, setCount] = useState(value);

  const decrement = () => {
    setCount((prev) => Math.max(min, prev - step));
  };

  const increment = () => {
    setCount((prev) => Math.min(max, prev + step));
  };

  return (
    <div className="flex items-center justify-center rounded-lg border border-gray-200 bg-white shadow-sm">
      <button
        type="button"
        onClick={decrement}
        className="h-8 w-8 text-lg font-semibold text-gray-600 hover:bg-gray-100"
        aria-label="Decrease servings"
      >
        −
      </button>
      <div className="h-8 w-10 text-center text-sm font-semibold text-gray-800 leading-8">
        {count}
      </div>
      <button
        type="button"
        onClick={increment}
        className="h-8 w-8 text-lg font-semibold text-gray-600 hover:bg-gray-100"
        aria-label="Increase servings"
      >
        +
      </button>
    </div>
  );
}
